import { Navigate, Outlet } from 'react-router-dom';

export const MaintenanceRoute = ({ isMaintenance, redirectPath = '/maintenance', children }) => {
  if (isMaintenance) {
    return <Navigate to={redirectPath} replace />;
  }
  return children ? children : <Outlet />;
};
